import { render } from "./UserNotification.vue?vue&type=template&id=2f300852&scoped=true"
import script from "./UserNotification.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserNotification.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserNotification.vue?vue&type=style&index=0&id=2f300852&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f300852"]])

export default __exports__